import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
document.title ="实名认证Demo";

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/views/index')
    },
    {
      path: '/quiet',
      name: 'quiet',
      component: () => import('@/views/quiet')
    },
    {
      path: '/trackIndex',
      name: 'trackIndex',
      component: () => import('@/views/trackIndex')
    },
  ]
})
